import Colors from "assets/Colors";
import { Layout, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import SubMenu from "antd/lib/menu/SubMenu";
import { useTranslation } from "react-i18next";
import s from "./styles";

const { Sider } = Layout;

function ItemsList({ items = [] }) {
  const navigate = useNavigate();
  const location = useLocation();
  return items.map((item) => (
    <s.ItemWrapper
      key={item.path}
      onClick={() => navigate(item.path)}
      selected={location.pathname.includes(item.path)}
      style={{ width: "183px" }}
    >
      {item.name}
      {location.pathname.includes(item.path) && <s.Line />}
    </s.ItemWrapper>
  ));
}

function SiderSecondary() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const infoSubMenus = (
    <ItemsList
      items={[
        {
          path: "/reports/sales",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.sells"),
        },
        {
          path: "/reports/payment_methods",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.pays"),
        },
        {
          path: "/reports/taxes",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.taxes"),
        },
        {
          path: "/reports/categories",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.categories"),
        },
        {
          path: "/reports/items",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.items"),
        },
        {
          path: "/reports/customers",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.customers"),
        },
        {
          path: "/reports/employee",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.employees"),
        },
      ]}
    />
  );

  const configSubMenus = (
    <ItemsList
      items={[
        {
          path: "/config/users",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.users"),
        },
        {
          path: "/config/security",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.security"),
        },
        {
          path: "/config/localizations",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.localizations"),
        },
      ]}
    />
  );

  const cash_management_SubMenus = (
    <ItemsList
      items={[
        {
          path: "/operations/sales",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.billing"),
        },
        {
          path: "/operations/endofday",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.pastClosures"),
        },
      ]}
    />
  );

  const inventorySubMenus = (
    <ItemsList
      items={[
        {
          path: "/inventory/items",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.items"),
        },
        {
          path: "/inventory/categories",
          name: t(
            "containers.SideBarTopMenuHOC.SiderSecondary.categoriesSubMenu"
          ),
        },
        {
          path: "/inventory/variants",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.variants"),
        },
        {
          path: "/inventory/modifiers",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.modifiers"),
        },
        {
          path: "/inventory/priceList",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.priceList"),
        },
      ]}
    />
  );

  const workersSubMenus = (
    <ItemsList
      items={[
        {
          path: "/employees/list",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.list"),
        },
        {
          path: "/employees/schedules",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.schedules"),
        },
      ]}
    />
  );

  const reservationsSubMenus = (
    <ItemsList
      items={[
        {
          path: "/reservations",
          name: t("containers.SideBarTopMenuHOC.SiderSecondary.reservations"),
        },
      ]}
    />
  );

  const settingsSubMenus = (
    <Menu
      mode="inline"
      style={{ fontSize: "13px", fontWeight: "500", marginTop: "-15px" }}
      defaultOpenKeys={["sub1"]}
      selectedKeys={
        location.pathname.includes("general")
          ? "1"
          : location.pathname.includes("store")
          ? "2"
          : location.pathname.includes("openhours")
          ? "3"
          : location.pathname.includes("owner")
          ? "4"
          : "1"
      }
    >
      <SubMenu
        key="sub1"
        title={t("containers.SideBarTopMenuHOC.SiderSecondary.companie")}
      >
        <Menu.Item
          style={{ fontSize: "13px", fontWeight: "500" }}
          key="1"
          onClick={() => [navigate("/settings/general")]}
        >
          {t("containers.SideBarTopMenuHOC.SiderSecondary.generalInformation")}
        </Menu.Item>
        <Menu.Item
          style={{ fontSize: "13px", fontWeight: "500" }}
          key="2"
          onClick={() => [navigate("/settings/store")]}
        >
          {t("containers.SideBarTopMenuHOC.SiderSecondary.storeSettings")}
        </Menu.Item>
        {/* <Menu.Item
          style={{ fontSize: "13px", fontWeight: "500" }}
          key="3"
          onClick={() => [navigate("/settings/openHours")]}
        >
          {t("containers.SideBarTopMenuHOC.SiderSecondary.storeHours")}
        </Menu.Item> */}
        <Menu.Item
          style={{ fontSize: "13px", fontWeight: "500" }}
          key="4"
          onClick={() => [navigate("/settings/owner")]}
        >
          {t("containers.SideBarTopMenuHOC.SiderSecondary.holderData")}
        </Menu.Item>
      </SubMenu>
      {/* <SubMenu
        key="sub2"
        title={t("containers.SideBarTopMenuHOC.SiderSecondary.preferences")}
      >
        <Menu.Item
          style={{ fontSize: "13px", fontWeight: "500" }}
          key="5"
          onClick={() => [navigate("/settings/editRooms")]}
        >
          {t("containers.SideBarTopMenuHOC.SiderSecondary.editRooms")}
        </Menu.Item>
      </SubMenu> */}
    </Menu>
  );

  const path = location.pathname;

  return (
    <Sider
      width={183}
      style={{
        background: Colors.background_secondary,
        paddingTop: "35px",
      }}
      zeroWidthTriggerStyle={{ top: "0" }}
    >
      {path.includes("/reports") && infoSubMenus}
      {path.includes("/operations") && cash_management_SubMenus}
      {path.includes("/config") && configSubMenus}
      {path.includes("/inventory") && inventorySubMenus}
      {path.includes("/employees") && workersSubMenus}
      {path.includes("/reservations") && reservationsSubMenus}
      {path.includes("/settings") && settingsSubMenus}
    </Sider>
  );
}

export default SiderSecondary;
